<template>
    <v-container fluid grid-list-md>
        <v-layout>
            <v-flex>
                <h1 class="display-3">ABC Clientes</h1>
                <div class="caption">
                    Muestra las ventas a clientes por empresa en monto ordenándolos individualmente según el importe.
                    Permite elegir cantidad o porcentaje respecto al monto total de clientes a discriminar individualmente y
                    agrupa el resto en “otros”. Permite elegir periodo a mostrar y moneda.
                    Los valores no incluyen impuestos.
                </div>
            </v-flex>
        </v-layout>
        <v-menu v-model="lateral" :close-on-content-click="false">
            <v-btn slot="activator" flat icon>
                <v-icon>menu</v-icon>
            </v-btn>
            <form>
                <v-card>
                    <v-card-text>
                        <empresa-select v-model="d.empresa"></empresa-select>
                        <moneda-select v-model="d.moneda"></moneda-select>
                        <v-menu
                                lazy
                                :close-on-content-click="false"
                                v-model="menuDesde"
                                :return-value.sync="menuDesde"
                                ref="menuDesde"
                        >
                            <v-text-field
                                    name="desde"
                                    slot="activator"
                                    label="Desde"
                                    v-model="d.desde"
                                    prepend-icon="event"
                                    readonly></v-text-field>
                            <v-date-picker
                                    v-model="d.desde"
                                    first-day-of-week="1"
                                    locale="es-sp"
                                    scrollable
                                    @input="$refs.menuDesde.save(date)"
                            ></v-date-picker>
                        </v-menu>
                        <v-menu
                                lazy
                                :close-on-content-click="false"
                                v-model="menuHasta"
                                transition="v-scale-transition"
                        >
                            <v-text-field
                                    name="desde"
                                    slot="activator"
                                    label="Hasta"
                                    v-model="d.hasta"
                                    prepend-icon="event"
                                    readonly
                                    ref="menuHasta"
                            ></v-text-field>
                            <v-date-picker
                                    v-model="d.hasta"
                                    first-day-of-week="1"
                                    locale="es-sp"
                                    scrollable
                                    @input="$refs.menuHasta.save(date)"
                            ></v-date-picker>
                        </v-menu>
                        <v-text-field name="limit" label="Mostrar" v-model="d.limit"></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn dark default @click.native="mostrar()" :loading="loading">MOSTRAR</v-btn>
                    </v-card-actions>
                </v-card>
            </form>
        </v-menu>
        <v-layout row wrap>
            <v-flex>
                <v-progress-linear :indeterminate="true" :query="true" :active="loading" height="5"></v-progress-linear>
                <highcharts style="width: 100%" :options="chartOptions"></highcharts>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
    import empresaSelect from '../../components/EmpresaSelect.vue'
    import monedaSelect from '../../components/MonedaSelect.vue'
    import moment from 'moment'

    export default {
        components: {empresaSelect, monedaSelect},
        data() {
            return {
                lateral:false,
                loading: false,
                menuDesde: false,
                menuHasta: false,
                empresas: [],
                monedas: [],
                d: {
                    epresa: '',
                    moneda: '',
                    desde: moment().subtract(1, 'day').format('YYYY-MM-DD'),
                    hasta: moment().format('YYYY-MM-DD'),
                    limit: 10
                },
                chartOptions: {
                    chart: {
                        type: 'pie'
                    },
                    title: {
                        text: 'ABC CLIENTES'
                    },
                    legend: {
                        enabled: true,
                    },
                    xAxis: {
                        type: 'category'
                    },
                    yAxis: {
                        title: {
                            text: 'Montos'
                        }
                    },
                    tooltip: {
                        pointFormat: '{point.name}: Monto: <b>{point.y:,.2f} ({point.percentage:.1f} %)</b>'
                    },
                    plotOptions: {
                        series: {
                            stacking: 'normal',
                            dataLabels: {
                                enabled: true,
                                format: '{point.name}: {point.y:,.2f} ({point.percentage:.1f} %)',
                            },
                            tooltip: {
                                pointFormat: '{point.name}: Monto: <b>{point.y:,.2f} ({point.percentage:.1f} %)</b>'
                            },
                        }
                    },
                    series: []
                }
            }
        },
        methods: {
            mostrar() {
                this.loading = true;
                this.$http.post('indicadores/abc-cliente', this.d)
                    .then(r => {
                        this.chartOptions.series = r.data.series;
                        this.loading = false;
                        this.lateral = false;
                    }, r => {
                        alert(r)
                        this.loading = false;
                    });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/indicadores/abc-clientes.vue